import React from 'react';
import clsx from 'clsx';
import {makeStyles} from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Container from '@material-ui/core/Container';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import {
    Event,
    EventNote,
    LocalLibrary as AdminsIcon,
    People as WorkersIcon,
    PermContactCalendar,
    Person,
    RoomService as ServiceIcon
} from "@material-ui/icons";
import {ListItem, ListItemIcon, ListItemText} from "@material-ui/core";
import {Link as RouterLink, useHistory, useLocation} from 'react-router-dom';
import {navMap} from "./navMap";
import logo_green from "../orderEngine/logo_green.png";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        padding: '0 24px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: 240,
    },
}));

const getHeadlineName = (pathName: string) => {
    /*if(pathName.startsWith('/admin/workers/worker')) {
        return 'Worker'
    } else */
    if (pathName.startsWith('/admin/workers')) {
        return 'Gartenarbeiter'
    }else if (pathName.startsWith('/admin/orders')) {
        return 'Aufträge'
    }
    if (pathName.startsWith('/admin/clients/client')) {
        return 'Kunde'
    } else if (pathName.startsWith('/admin/clients')) {
        return 'Kunden'
    } else if (pathName.startsWith('/admin/calendar')) {
        return 'Kalender'
    } else if (pathName.startsWith('/admin/services')) {
        return 'Dienstleistungen'
    } else if (pathName.startsWith('/admin/admins/admin')) {
        return 'Admin'
    } else if (pathName.startsWith('/admin/admins')) {
        return 'Admins'
    }
}

export default function MainFrame({children}: { children: React.ReactElement }) {
    const classes = useStyles();
    const history = useHistory();
    const [open, setOpen] = React.useState(true);
    const handleDrawerOpen = () => {
        setOpen(true);
    };
    const handleDrawerClose = () => {
        setOpen(false);
    };
    const location = useLocation();

    return (
        <div className={classes.root}>
            <CssBaseline/>
            <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
                <Toolbar className={classes.toolbar}>
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
                    >
                        <MenuIcon/>
                    </IconButton>
                    <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                        {getHeadlineName(location.pathname)}
                    </Typography>
                    <IconButton color="inherit" onClick={() => history.push("/admin/settings")}>
                            <Person/>
                    </IconButton>
                </Toolbar>
            </AppBar>
            <Drawer
                variant="permanent"
                classes={{
                    paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
                }}
                open={open}
            >
                <div className={classes.toolbarIcon}>
                    <img
                        style={{height: 60}}
                        alt="logo"
                        src={logo_green}
                    />
                    <IconButton onClick={handleDrawerClose} edge="end">
                        <ChevronLeftIcon/>
                    </IconButton>
                </div>
                <Divider/>
                <List>
                    <ListItem
                        button
                        component={RouterLink}
                        to={navMap.calendar.path}
                        selected={location.pathname.startsWith(navMap.calendar.path)}
                    >
                        <ListItemIcon>
                            <Event/>
                        </ListItemIcon>
                        <ListItemText primary="Kalender"/>
                    </ListItem>
                    <ListItem
                        button
                        component={RouterLink}
                        to={navMap.orders.path}
                        selected={location.pathname.startsWith(navMap.orders.path)}
                    >
                        <ListItemIcon>
                            <EventNote/>
                        </ListItemIcon>
                        <ListItemText primary="Aufträge"/>
                    </ListItem>
                    <ListItem
                        button
                        component={RouterLink}
                        to={navMap.clients.path}
                        selected={location.pathname.startsWith(navMap.clients.path)}
                    >
                        <ListItemIcon>
                            <PermContactCalendar/>
                        </ListItemIcon>
                        <ListItemText primary="Kunden"/>
                    </ListItem>
                    <ListItem
                        button component={RouterLink}
                        to={navMap.workers.path}
                        selected={location.pathname.startsWith(navMap.workers.path)}
                    >
                        <ListItemIcon>
                            <WorkersIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Gartenarbeiter"/>
                    </ListItem>
                    <ListItem
                        button
                        component={RouterLink}
                        to={navMap.services.path}
                        selected={location.pathname.startsWith(navMap.services.path)}
                    >
                        <ListItemIcon>
                            <ServiceIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Dienstleistungen"/>
                    </ListItem>
                    <ListItem
                        button
                        component={RouterLink}
                        to={navMap.admins.path}
                        selected={location.pathname.startsWith(navMap.admins.path)}
                    >
                        <ListItemIcon>
                            <AdminsIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Admins"/>
                    </ListItem>
                </List>
            </Drawer>
            <main className={classes.content}>
                <div className={classes.appBarSpacer}/>
                <Container maxWidth="lg" className={classes.container}>
                    {children}
                </Container>
            </main>
        </div>
    );
}
